import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
    state: {
        barColor: 'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
        barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-2.jpg',
        drawer: true,
        value: 0,
      },
      getters,
      mutations,
      actions,
}
